import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import ensembleImage from "../images/ensemble.jpg"

const English: React.FC = () => (
  <Layout>
    <SEO title="Kaamos in English" />

    <div className="columns">
      <div className="column is-8">
        <h3 className="title is-3">Kaamos in English</h3>

        <p className="block">
          The <strong>Kaamos Chamber Choir</strong> was founded in 2007 by Dani
          Juris who also conducted the choir in 2007-2016. The choir consists of
          experienced choral singers who come from a wide variety of
          backgrounds. In June 2011, the choir participated in the chorus review
          at the Tampere Vocal Music Festival, where it was granted the rarely
          awarded Grand Prix and the highest accolade of three gold stamps.
          Kaamos has also been highly awarded in the 47th International Choir
          Competition in Spittal an der Drau, Austria, and in the International
          May Choir Competition prof. Georgi Dimitrov, Bulgaria. The choir
          participated in the International Harald Andersén Chamber Choir
          Competition in Helsinki in 2009 and 2012.
        </p>

        <p className="block">
          Kaamos's repertoire focuses on European a cappella works from German
          Romantic to Scandinavian contemporary, also including early music. The
          choir has released two albums: Valossa (”From Darkness To Light”, Alba
          Records, 2012) and Pyhä yö (”Sacred Night”, 2014). The choir has also
          performed together with, among others, the Finnish Radio Symphony
          Orchestra and the Helsinki Baroque Orchestra, and commissioned and
          premiered several new choral works.
        </p>

        <p className="block">
          Since 2016, The Kaamos Chamber Choir has been conducted by{" "}
          <strong>Visa Yrjölä</strong>.
        </p>

        <p className="block">
          Visa Yrjölä (b. 1992) received his Master of Music degree in choral conducting from the Sibelius Academy (University of the Arts, Helsinki) in 2018. He has also done exchange studies at the University of Music and Performing Arts, Vienna. Besides being the artistic leader of the Kaamos Chamber Choir, he conducts two award-winning male voice choirs in Finland: the Euga Male Voice Choir and the Helsinki Academic Male Choir KYL. He has served as a guest conductor in projects with several Finnish groups including Key Ensemble and Somnium Ensemble.  
        </p>

        <p className="block">
          Yrjölä has attended several masterclasses organized by Tenso, the European Network for Professional Chamber Choirs, working with Cappella Amsterdam, the Helsinki Chamber Choir, the Netherlands Chamber Choir, the Slovenian Philharmonic Choir, and the Croatian Radiotelevision Choir. He has also attended a masterclass with the Rundfunkchor Berlin. In 2013, the Tampere Vocal Music Festival awarded Visa Yrjölä a special prize for a young and promising conductor, and in June 2018, he was awarded the best conductor’s prize at the Bratislava Choir Festival. The Finnish radio channel Radio Classic awarded him the Tempo Award for young musicians in the conductors’ category in 2019.
        </p>

        <h4 className="title is-4">Contact:</h4>

        <p className="block">
          <strong>Visa Yrjölä</strong>
          <br />
          Artistic director
          <br />
          +358 40 521 89769
          <br />
          visa.yrjola@gmail.com
        </p>
        <p className="block">
          <strong>Jussi Alaranta</strong>
          <br />
          President
          <br />
         
          kamarikuorokaamos@gmail.com
        </p>
      </div>
    </div>
  </Layout>
)

export default English
